import {onDomReady} from "./observer.js";

class OnloadPopup {
    constructor() {
        this.options = {
            popupmarkup: '[data-onload-popup]',
        };

        this.elements = {
            popupElements: document.querySelectorAll(this.options.popupmarkup),
        };

        this.currentIndex = 0;

        this.init();
    }

    init() {
        if (this.elements.popupElements.length > 0) {
            this.showNextPopup();
        }
    }

    showNextPopup = () => {
        if (this.currentIndex >= this.elements.popupElements.length) return;

        // Remove all existing popups
        document.querySelectorAll('.onload-popup').forEach(popup => {
            popup.remove();
        });

        // Create and show current popup
        const message = this.elements.popupElements[this.currentIndex].getAttribute('data-onload-popup');
        if (message) {
            const popup = document.createElement('div');
            popup.classList.add('onload-popup');
            popup.textContent = message;
            document.body.appendChild(popup);

            // Add _opened class with a slight delay to trigger animation
            setTimeout(() => {
                popup.classList.add('_opened');
            }, 200);

            setTimeout(() => {
                popup.classList.remove('_opened');
                setTimeout(() => {
                    popup.remove(); // Remove popup after animation
                    this.currentIndex++;
                    this.showNextPopup();
                }, 1000); // Delay for removal animation
            }, 5000);
        } else {
            this.currentIndex++;
            this.showNextPopup();
        }
    }
}

onDomReady(() => {
    new OnloadPopup();
}, false);